// This is a COPY of downread/shared/src/schema/site-css.ts. To modify, edit the original and then run downread/bin/build-shared.sh
// Per-site stylesheets (sync-server/site-css/): the naming rules shared by the sync server, which
// keys and publishes the stylesheets, and the client, which loads them and tags post cards.
// Keep this file free of imports so build-shared.sh can copy it to frontend/src/schema-copy.

/**
 * The domain a site stylesheet is keyed by: the URL's host, lowercased, without a leading `www.`.
 * Undefined when the URL has no host (unparsable, or a newsletter's mailto: URL).
 */
export function siteDomain(url: string | undefined): string | undefined {
    if (!url) return undefined;
    try {
        return new URL(url).hostname.toLowerCase().replace(/^www\./, '') || undefined;
    } catch {
        return undefined;
    }
}

/**
 * The class that marks a post card as belonging to a site, and that every rule of the site's
 * stylesheet is prefixed with: `feed-<domain>` with dots turned into underscores, so a stylesheet
 * writes `.feed-nytimes_com` instead of the escaped `.feed-nytimes\.com`. Underscores can't occur
 * in a hostname, so the mapping is unambiguous.
 */
export const siteCssClass = (domain: string): string => `feed-${domain.replace(/\./g, '_')}`;

/**
 * CDN path of a site stylesheet, relative to the CDN base URL. The content hash is part of the
 * name, so every object is immutable and cacheable forever; a changed stylesheet gets a new path,
 * and feeds pick it up (Feed.siteCss) on their next fetch.
 */
export const siteCssPath = (domain: string, hash: string): string => `site-css/${domain}.${hash}.css`;
